import React from 'react';
import * as Card from '../../v2BaseComponents/Card';
import { APITypes } from '../../../primary-record-types';
import Icon from '../../v2BaseComponents/Icon';

export type FolderCardOwnProps = {
    onPress?: () => void;
    folder: APITypes.medicalProfileFilesService.FolderWithDescendantFileCount;
    isDisabled?: boolean;
};

export type FolderCardProps = FolderCardOwnProps;

const FolderCard: React.FC<FolderCardProps> = (props) => {
    return (
        <Card.Card onPress={props.onPress} isDisabled={props.isDisabled} testID="folder-card">
            <Card.CardLeftContent leftContent={<Icon size="card-list-icon" name="Folder" />}>
                <Card.CardRightContent
                    rightContent={<Card.CardListHeader>{`${props.folder.descendantFilesCount}`}</Card.CardListHeader>}
                >
                    <Card.CardListHeader>{props.folder.folderName}</Card.CardListHeader>
                </Card.CardRightContent>
            </Card.CardLeftContent>
        </Card.Card>
    );
};

export default React.memo(FolderCard);
